<template>
    <activix-modal size="lg" portal="modal-2" :opened="opened" :closable="false">
        <template #header>
            <h4 class="modal-title">
                {{ $t('addLead.originalEmail') }}
            </h4>
        </template>
        <template #body>
            <tiptap size="sm" @update:model-value="$emit('update:originalEmail', $event)" />
        </template>
        <template #footer>
            <div class="flex justify-end">
                <activix-button @click="$emit('close')">
                    {{ $t('general.cancel') }}
                </activix-button>
                <activix-button type="primary" :disabled="disabled" @click="$emit('close')">
                    {{ $t('general.save') }}
                </activix-button>
            </div>
        </template>
    </activix-modal>
</template>

<script>
    import Tiptap from '@/components/composer/Tiptap.vue';

    export default {
        emits: ['update:originalEmail', 'close'],

        components: {
            Tiptap,
        },

        props: {
            opened: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
